<template>
  <a-card :bordered="false">
    <!-- 検索区域 -->
    <div class="table-page-search-wrapper">
      <a-form-model :layout="isMobile() ? '' : 'inline'" @keyup.enter.native="searchQuery(false, false)">
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="5">
            <a-form-model-item label="关键字">
              <a-input
                :placeholder="this.$t('disp.ph.matchOr', ['用户编号', '姓名'])"
                v-model="queryParam.username"
              ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :xs="1" :sm="1" class="width-fit-content">
            <a-form-model-item :wrapperCol="{ span: 24 }">
              <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                $t('disp.btn.search')
              }}</a-button>
              <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <!-- ボタン操作区域 -->
    <div class="table-operator" style="border-top: 5px" v-if="!isModal">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ this.$t('disp.btn.add') }}</a-button>
      <!-- <a-button type="primary" icon="cloud-download" @click="handleExport">导出</a-button> -->
      <!--<a-button @click="handleInitPassword(false)" type="danger">重置密码</a-button>-->
      <!--<a-button @click="handleInitPassword(true)" type="danger" ghost>填充密码</a-button>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1">
            <a-icon type="lock" @click="batchFrozen('2')" />
            {{ this.$t('disp.btn.frozenBatch') }}
          </a-menu-item>
          <a-menu-item key="2">
            <a-icon type="unlock" @click="batchFrozen('1')" />
            {{ this.$t('disp.btn.unFrozenBatch') }}
          </a-menu-item>
          <a-menu-item key="3">
            <a-icon type="close" @click="batchDel" :title="this.$t('msg.confirm.deleteBatch')" />
            {{ this.$t('disp.btn.deleteBatch') }}
          </a-menu-item>
        </a-menu>
        <a-button>
          {{ $t('disp.btn.operationBatch') }}
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info div-selected-info">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ this.$t('disp.selected') }}
        <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
        {{ this.$t('disp.item') }}
        <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
      </div>

      <a-table
        ref="table"
        tableLayout="auto"
        class="action"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowClassName="rowClassName"
        :rowSelection="
          isModal
            ? {
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange,
                type: isMulti ? 'checkbox' : 'radio',
              }
            : {
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange,
                getCheckboxProps: (record) => ({
                  props: { disabled: record.username == 'admin' || record.delFlag == 1 },
                }),
              }
        "
        @change="handleTableChange"
      >
        <template slot="avatarslot" slot-scope="text, record">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user" />
          </div>
        </template>

        <div slot="entryDay" slot-scope="text, record">
          {{ record.entryDay ? moment(record.entryDay).format('YYYY-MM-DD') : '' }}
        </div>

        <div slot="retirementDay" slot-scope="text, record">
          {{ record.retirementDay ? moment(record.retirementDay).format('YYYY-MM-DD') : '' }}
        </div>

        <span slot="roles" slot-scope="text, record">
          <a-tag color="purple" class="tag-role" v-for="row in record.roles" :key="row.id">{{ row.roleName }}</a-tag>
        </span>

        <!-- 在職状態 -->
        <span slot="delFlag" slot-scope="text, record">
          <!-- 系统用户 -->
          <a-tag color="blue" v-if="record.delFlag == '0' && !record.employeeType && !record.entryDay">系统用户</a-tag>
          <!-- 离职 -->
          <a-tag v-else-if="record.delFlag == '1' && record.retirementDay">离职</a-tag>
          <!-- 削除 -->
          <a-tag v-else-if="record.delFlag == '1' && !record.retirementDay">删除</a-tag>
          <!-- 等待入职 -->
          <a-tag color="orange" v-else-if="record.delFlag == '-1'">等待入职</a-tag>
          <!-- 即将离职 -->
          <a-tag
            color="red"
            v-else-if="
              record.delFlag == '0' && record.retirementDay && moment(record.retirementDay).isAfter(moment(new Date()))
            "
            >即将离职</a-tag
          >
          <!-- 试用期 -->
          <a-tag color="cyan" v-else-if="!record.regularFlag">试用期</a-tag>
          <!-- 在职 -->
          <a-tag color="green" v-else>在职</a-tag>
        </span>

        <!-- <span slot="externalStaff" slot-scope="text, record">
          <span v-if="record.username == 'admin'"></span>
          <a-tag color="blue" v-else-if="record.externalStaff == '0'">{{
            $getDict('external_staff', record.externalStaff)
          }}</a-tag>
          <a-tag color="pink" v-else-if="record.externalStaff == '1'">{{
            $getDict('external_staff', record.externalStaff)
          }}</a-tag>
          <span v-else></span>
        </span> -->

        <span slot="status" slot-scope="text, record">
          <a-tag color="green" v-if="record.status == 1">{{ $getDict('user_status', record.status) }}</a-tag>
          <a-tag color="blue" v-else>{{ $getDict('user_status', record.status) }}</a-tag>
        </span>

        <span slot="action" slot-scope="text, record" v-if="record.username == 'admin'">{{
          $t('disp.canNotEdit').format(record.realname)
        }}</span>
        <span slot="action" slot-scope="text, record" v-else>
          <a :disabled="record.delFlag == 1" @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm
            v-if="record.status == 1"
            :title="$t('msg.flow.confirm.freeze')"
            @confirm="() => handleFrozen(record.id, 2, record.username)"
          >
            <a :disabled="record.delFlag == 1">{{ $t('disp.flow.freeze') }}</a>
          </a-popconfirm>
          <a-divider v-if="record.status == 1" type="vertical" />
          <a-popconfirm
            v-if="record.status == 2"
            :title="$t('msg.flow.confirm.unfreeze')"
            @confirm="() => handleFrozen(record.id, 1, record.username)"
          >
            <a :disabled="record.delFlag == 1">{{ $t('disp.flow.unfreeze') }}</a>
          </a-popconfirm>
          <a-divider v-if="record.status == 2" type="vertical" />
          <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.id)">
            <a :disabled="record.delFlag == 1">{{ $t('disp.btn.delete') }}</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>
  </a-card>
</template>

<script>
import { putAction, postAction, getFileAccessHttpUrl, deleteAction, getAction, downFile } from '@/api/manage'
import { frozenBatch } from '@/api/api'
import { tableMixin } from '@/mixins/tableMixin'
import { mixin, mixinDevice } from '@/utils/mixin.js'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import UserModal from './modules/UserModal'
import moment from 'moment'

export default {
  name: 'UserManage',
  mixins: [mixin, mixinDevice, tableMixin],
  components: {
    UserModal,
    JDictSelectTag,
  },
  props: {
    // 是否弹出框
    isModal: {
      type: Boolean,
      default: false,
    },
    // 是否多选
    isMulti: {
      type: Boolean,
      default: false,
    },
    // 父组件
    parent: {
      type: String,
      default: '',
    },
    // 选中行
    selectionRows: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      description: '用户管理画面',
      queryParam: {},
      userStatus: [],
      columns: [
        {
          title: this.$t('disp.username'),
          align: 'left',
          dataIndex: 'username',
        },
        {
          title: this.$t('disp.realname'),
          align: 'left',
          dataIndex: 'realname',
        },
        {
          title: '电话号码',
          align: 'left',
          dataIndex: 'phone',
        },
        {
          title: this.$t('disp.email'),
          align: 'left',
          dataIndex: 'email',
        },
        {
          // 入社日
          title: '入职日期',
          dataIndex: 'entryDay',
          align: 'left',
          //width: 120,
          scopedSlots: { customRender: 'entryDay' },
        },
        {
          // 退職日
          title: this.$t('disp.retireDay'),
          dataIndex: 'retirementDay',
          align: 'left',
          //width: 120,
          scopedSlots: { customRender: 'retirementDay' },
        },
        //{
        //  // 角色
        //  title: '角色',
        //  dataIndex: 'roles',
        //  align: 'left',
        //  //width: 120,
        //  scopedSlots: { customRender: 'roles' },
        //},
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'status' },
        },
        // {
        //   // 在職状態
        //   title: '在职状态',
        //   dataIndex: 'delFlag',
        //   scopedSlots: { customRender: 'delFlag' },
        //   align: 'center',
        //   width: 100,
        // },
        // {
        //   // 本公司 / 外协
        //   title: '本公司 / 外协',
        //   dataIndex: 'externalStaff',
        //   scopedSlots: { customRender: 'externalStaff' },
        //   align: 'center',
        //   width: 100 
        // }
      ],
      url: {
        imgerver: window._CONFIG['staticDomainURL'],
        syncUser: '/process/extActProcess/doSyncUser',
        list: '/blaze-sys/k00/k0014/UserManage/list',
        delete: '/blaze-sys/k00/k0014/UserManage/delete',
        deleteBatch: '/blaze-sys/k00/k0014/UserManage/deleteBatch',
        export: '/blaze-sys/k00/k0014/UserManage/export',
        initPassword: '/blaze-sys/k00/k0014/UserManage/initPassword',
      },
    }
  },
  computed: {},
  created() {
    // 不为弹窗则新增编辑
    if (!this.isModal) {
      this.columns.push({
        title: this.$t('disp.operation'),
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
        align: 'center',
      })
    }
  },
  methods: {
    moment,
    searchReset() {
      this.queryParam = {}
      this.userStatus = []
      // this.userStatus = []
      // this.selectedRowKeys = []
      // this.selectionRows = []
    },
    handleInitPassword(fillMode) {
      var that = this
      this.$confirm({
        title: fillMode ? '该操作会给无密码人员设置默认密码' : '该操作会重置全员的密码',
        content: (h) => <div style="color:red;">请务必确认无误之后再点击确定按钮</div>,
        onOk() {
          if (that.loading) {
            return
          } else {
            that.loading = true
          }

          postAction(that.url.initPassword, { fillMode: fillMode })
            .then((res) => {
              if (res.success) {
                that.$message.success('处理成功')
              }
            })
            .finally(() => {
              that.loading = false
            })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    changeStatus(val) {
      this.userStatus = val
    },
    getAvatarView: function (avatar) {
      if (avatar && avatar != '[]') {
        return getFileAccessHttpUrl(avatar, this.url.imgerver, 'http')
      }
    },
    batchFrozen: function (status) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t('disp.rules.select'))
        return false
      } else {
        let ids = ''
        let that = this
        that.selectedRowKeys.forEach(function (val) {
          ids += val + ','
        })
        that.$confirm({
          title: this.$t('disp.warn'),
          content: status == 1 ? this.$t('msg.W_K0014002_06') : this.$t('msg.W_K0014002_04'),
          onOk: function () {
            frozenBatch({ ids: ids, status: status }).then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.searchQuery(true, true)
                that.onClearSelected()
              }
            })
          },
        })
      }
    },
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error(this.$t('disp.setUrlDeleteBatch'))
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t(disp.rules.select))
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        var that = this
        this.$confirm({
          title: this.$t('disp.warn'),
          content: this.$t('msg.confirm.deleteBatch'),
          onOk: function () {
            if (that.loading) {
              return
            } else {
              that.loading = true
            }

            deleteAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(that.$t(res.message))
                  that.searchQuery(true, false)
                  that.onClearSelected()
                }
              })
              .finally(() => {
                that.loading = false
              })
          },
        })
      }
    },
    handleFrozen: function (id, status, username) {
      let that = this
      frozenBatch({ ids: id, status: status }).then((res) => {
        if (res.success) {
          that.$message.success(that.$t(res.message))
          that.searchQuery(true, true)
        }
      })
    },
    handleMenuClick(e) {
      if (e.key == 1) {
        this.batchFrozen(2)
      } else if (e.key == 2) {
        this.batchFrozen(1)
      } else if (e.key == 3) {
        this.batchDel()
      }
    },
    handleExport() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.export, {})
        .then((res) => {
          if (res.success) {
            // 处理成功
            downloadFile(res.message)
            this.$message.success(this.$t('msg.operation.success'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style scoped lang="less">
.tag-role {
  width: auto !important;
  margin: 2px 3px 2px 0 !important;
}
</style>

